import { createContext } from 'react'

interface SettingsContextType {
  showSidebar: boolean
  setShowSidebar: React.Dispatch<React.SetStateAction<boolean>>
}

export const SettingsContext = createContext<SettingsContextType | undefined>(undefined)
